import styles from './EditLayout.module.scss'
import { PropsWithChildren } from 'react'
import { EditLayoutProps } from './types.ts'
import { useNavigate } from 'react-router'
import { Button, Heading } from '@boltenergy-be/design-system'
import useWindowSize from 'hooks/useWindowSize.tsx'
import classNames from 'classnames'
import { keyFromSelector } from 'i18next'
import { useTranslation } from 'react-i18next'
import SupportFooter from 'layouts/components/support-footer/SupportFooter.tsx'

const EditLayout = ({ children, title, classes, backUrl, withFooter }: PropsWithChildren<EditLayoutProps>) => {
  // i18n
  const { t } = useTranslation()

  // Router
  const navigate = useNavigate()

  // Window size
  const { isTablet } = useWindowSize()

  return (
    <>
      <header className={classNames(styles.header, classes?.header)}>
        <Button
          size={isTablet ? 'small' : 'large'}
          variant="tertiary"
          leadingIcon="arrowLeft"
          onClick={() => (backUrl ? navigate(backUrl) : navigate(-1))}
          className={styles.back}
          title={t(($) => $.back)}
        />

        <div className={styles['title-wrapper']}>
          {typeof title === 'string' ? (
            <Heading as="h1" variant={isTablet ? 'h4' : 'h1'} serif>
              {title}
            </Heading>
          ) : (
            title
          )}
        </div>
      </header>

      <div className={classNames(styles.wrapper, classes?.body, { [styles['with-footer']]: withFooter })}>{children}</div>

      {withFooter && <SupportFooter ns="common" i18nKey={keyFromSelector(($) => $.supportFooter)} />}
    </>
  )
}

export default EditLayout
